/**
 * 로그인 페이지
 */

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, Form, Button, Alert } from 'react-bootstrap';
import { useAuth } from '../../contexts/AuthContext';

const Login: React.FC = () => {
  const navigate = useNavigate();
  const { login, isLoading } = useAuth();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);

    try {
      await login(email, password);
      navigate('/admin/dashboard');
    } catch (err: any) {
      setError(err.response?.data?.error?.message || '로그인에 실패했습니다.');
    }
  };

  return (
    <Container fluid className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh', backgroundColor: '#2E2E3A' }}>
      <Row className="w-100">
        <Col md={4} className="mx-auto">
          <Card style={{ backgroundColor: '#3A4B5C', border: 'none', borderRadius: '12px' }}>
            <Card.Body className="p-5">
              <h2 className="text-center mb-4" style={{ color: '#fff' }}>Lumin Art Admin</h2>

              {error && (
                <Alert variant="danger" className="mb-3">
                  {error}
                </Alert>
              )}

              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label style={{ color: '#fff' }}>이메일 또는 사용자명</Form.Label>
                  <Form.Control
                    type="text"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    style={{ backgroundColor: '#2E2E3A', border: '1px solid #4A5B6C', color: '#fff' }}
                  />
                </Form.Group>

                <Form.Group className="mb-4">
                  <Form.Label style={{ color: '#fff' }}>비밀번호</Form.Label>
                  <Form.Control
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    style={{ backgroundColor: '#2E2E3A', border: '1px solid #4A5B6C', color: '#fff' }}
                  />
                </Form.Group>

                <Button
                  type="submit"
                  className="w-100"
                  disabled={isLoading}
                  style={{ backgroundColor: '#00BCD4', border: 'none', borderRadius: '8px', padding: '12px' }}
                >
                  {isLoading ? '로그인 중...' : '로그인'}
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Login;

